import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ConfigurationService } from '../Configuration/Configuration.service';

@Injectable()
export class MonitoringService {

    private readonly appInsights: ApplicationInsights;

    /**
     * 
     * @param configService
     * 
     * See: https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript#npm-based-setup
     * See: https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript#telemetry-initializers
     * See: https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript-angular-plugin
     * See: https://github.com/microsoft/applicationinsights-angularplugin-js
     */
    constructor(configService: ConfigurationService) {

        if (configService &&
            configService.config &&
            configService.config.appInsightsInstrumentationKey &&
            configService.config.appInsightsInstrumentationKey != "") {

            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: configService.config.appInsightsInstrumentationKey
                }
            });

            this.appInsights.loadAppInsights();

            this.appInsights.addTelemetryInitializer((envelope) => {
                envelope.tags["ai.cloud.role"] = "IWS Automation SPA";
            });

            this.appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
        }
    }

    /**
     * .
     * 
     * @param name
     * @param url
     * @param properties
     * @param measurements
     * @param duration
     */
    logPageView(name?: string, url?: string, properties?: any, measurements?: any, duration?: number) {

        console.info(`Page view: ${url}`);

        if (this.appInsights) {
            this.appInsights.trackPageView({
                name: name,
                uri: url,
                properties: properties,
                measurements: measurements
            });
        }
    }

    /**
     * .
     * 
     * @param name
     * @param properties
     * @param measurements
     */
    logEvent(name: string, properties?: any, measurements?: any) {

        console.info(`Event: ${name} ${JSON.stringify(properties)} ${JSON.stringify(measurements)}`);

        if (this.appInsights) {
            this.appInsights.trackEvent({
                name,
                properties,
                measurements
            });
        }
    }

    /**
     * .
     * 
     * @param exception
     * @param string
     * @param properties
     * @param measurements
     * @param severityLevel
     */
    logException(exception: Error, properties?: any, measurements?: any, severityLevel?: any) {

        console.error(`${exception.name} : ${exception.message} - ${JSON.stringify(properties)}`);

        if (this.appInsights) {
            this.appInsights.trackException({
                exception: exception,
                severityLevel: severityLevel,
                properties: properties,
                measurements: measurements
            });
        }
    }

    /**
     * .
     * 
     * @param message
     * @param properties
     * @param measurements
     * @param severityLevel
     */
    logTrace(message: string, properties?: any, measurements?, severityLevel?: any) {

        console.trace(`Trace: ${message} (${JSON.stringify(severityLevel)}) ${JSON.stringify(properties)}`);

        if (this.appInsights) {
            this.appInsights.trackTrace({
                message: message,
                severityLevel: severityLevel,
                properties: properties,
                measurements: measurements
            });
        }
    }
} 